<template>
    <div class="change-password-component-container">
        <div class="component-wrapper">
            <AppHeader />
            <div class="change-password-page-container scroll-bar">
                <div v-if="loadingPage" class="spinner-container">
                    <div class="spinner loading-spinner">
                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                    </div>
                </div>
                <div v-if="successLoadingPage && !loadingPage" class="change-password-page-wrapper">
                    <div v-if="!changingPasswordSuccesseded" class="change-password-form-container">
                        <div class="form-container">
                            <form class="change-password-form" @submit="changePasswordHandle">
                                <div class="info-text-container">
                                    <p class="info-text">
                                        {{ $t('change_the_password') }}
                                    </p>
                                </div>

                                <div class="input-container">
                                    <div class="form-section-wrapper password-section-container">
                                        <div class="show-hide-password-container" @click="showHidePassword('current')">
                                            <img :src="require(`../../assets/icons/${showCurrentPassword ? 'show' : 'hide'}_password.png`)"
                                                alt="password icon">
                                        </div>
                                        <div class="password-input-container">
                                            <input id="current-password" class="form-input" name="current-password"
                                                :class="[{'blocked': changingPasswordLoading}]"
                                                :type="showCurrentPassword ? 'text' : 'password'"
                                                :placeholder="$t('enter_current_password')" required />
                                        </div>
                                    </div>
                                </div>

                                <div class="input-container">
                                    <div class="form-section-wrapper password-section-container">
                                        <div class="show-hide-password-container" @click="showHidePassword('new')">
                                            <img :src="require(`../../assets/icons/${showNewPassword ? 'show' : 'hide'}_password.png`)"
                                                alt="password icon">
                                        </div>
                                        <div class="password-input-container">
                                            <input id="new-password" class="form-input"
                                                :class="[{ 'blocked': changingPasswordLoading }, passwordLengthInvalid ? 'error-password-length' : passwordStrength]"
                                                name="new-password" :type="showNewPassword ? 'text' : 'password'"
                                                @keyup="checkPasswordStrength" @blur="checkPasswordLength"
                                                :placeholder="$t('create_new_password')" required />
                                        </div>
                                    </div>
                                    <div v-if="showPasswordMsg" class="password-length-strength-msg-container">
                                        <p :class="passwordMsgColor">{{ $t(`${passwordMsg}`) }}</p>
                                    </div>
                                </div>

                                <div class="input-container">
                                    <div class="form-section-wrapper">
                                        <input id="confirm-password" class="form-input"
                                            :class="[{'error-password-not-match': confirmPasswordNotMatch, 'blocked': changingPasswordLoading}]"
                                            name="confirm-password" type="password" :placeholder="$t('re_enter_password')"
                                            required />
                                    </div>
                                    <div v-if="confirmPasswordNotMatch" class="error-msg-password-not-match-container">
                                        <p class="red">{{ $t('password_does_not_match') }}</p>
                                    </div>
                                </div>

                                <div class="form-section-wrapper change-password-btn-container">
                                    <div class="change-password-btn-wrapper">
                                        <div v-if="changingPasswordLoading" class="loading-spinner-container">
                                            <div class="spinner">
                                                <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                                            </div>
                                        </div>
                                        <input v-else id="change-password-btn" class="change-password-btn btn" type="submit"
                                            :value="$t('confirm')" />
                                    </div>

                                    <div class="change-password-info-msg-container">
                                        <p v-if="changingPasswordFailed" class="change-password-info-msg red">
                                            {{ $t(`${changingPasswordErrMsg}`) }}
                                        </p>
                                    </div>
                                </div>

                                <div class="can-not-reset-password-text-container">
                                    <p>{{ $t('cant_change_password') }}</p>
                                    <p>{{ $t('ask_trainer_for_hulp') }}</p>
                                </div>
                                <div class="back-to-settings-page-container">
                                    <div class="back-to-settings-page-btn-container">
                                        <p @click="backToSettings">{{ $t('back_to_settings') }}</p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div v-else class="password-change-success-container">
                        <div class="password-change-success-content-container">
                            <div class="info-text-container">
                                <p class="info-text">
                                    {{ $t('password_changed_successfully') }}
                                </p>
                            </div>
                            <div class="back-to-settings-btn-container">
                                <div class="back-to-settings-btn" @click="backToSettings">{{ $t('back') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                
                
                
                <!-- <div v-if="!failedLoadingPage" class="fialed-loading-page-container">
                    <div class="info-text-container">
                        <p class="info-text">
                            {{ $t('something_went_wrong_try_again') }}
                        </p>
                    </div>
                    <div class="reload-btn-container">
                        <div class="reload-btn" @click="reloadPage">{{ $t('reload') }}</div>
                    </div>
                </div> -->
            </div>
            <AppFooter />
        </div>
    </div>
</template>

<script>
import AppHeader from './AppHeader.vue';
import AppFooter from './AppFooter.vue';
import { passwordStrength } from 'check-password-strength';
export default {
    name: 'ChangePasswordPage',
    props: {
    },
    components: {
        AppHeader,
        AppFooter,
    },
    data() {
        return {
            changingPasswordLoading: false,
            changingPasswordFailed: false,
            changingPasswordSuccesseded: false,
            changingPasswordErrMsg: '',
            passwordMsg: '',
            showCurrentPassword: false,
            showNewPassword: false,
            showPasswordMsg: false,
            confirmPasswordNotMatch: false,
            passwordStrength: '',
            passwordLengthInvalid: false,
            loadingPage: true,
            successLoadingPage: false,
            failedLoadingPage: false,
        };
    },
    methods: {
        showHidePassword: function (passwordFiled) {
            if (passwordFiled == 'current') {
                this.showCurrentPassword = !this.showCurrentPassword;
            }
            else if (passwordFiled == 'new') {
                this.showNewPassword = !this.showNewPassword;
            }
        },
        checkPasswordStrength: function () {
            this.confirmPasswordNotMatch = false;
            this.showPasswordMsg = false;
            this.passwordLengthInvalid = false;
            this.passwordMsg = '';
            this.passwordStrength = '';
            this.passwordMsgColor = 'red';
            const passwordInput = document.getElementById('new-password');

            if (passwordInput.value != "") {
                const passwordStrengthResult = passwordStrength(passwordInput.value).value;
                // console.log(passwordStrengthResult);

                switch (passwordStrengthResult) {
                    case "Too weak":
                    case "Weak": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_weak';
                        this.passwordStrength = 'weak';
                        this.passwordMsgColor = 'red';
                    }
                        break;
                    case "Medium": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_ok';
                        this.passwordStrength = 'medium';
                        this.passwordMsgColor = 'blue';
                    }
                        break;
                    case "Strong": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_strong';
                        this.passwordStrength = 'strong';
                        this.passwordMsgColor = 'green';
                    }
                }
            }
            else {
                this.checkPasswordLength();
            }
        },
        checkPasswordLength: function () {
            if (!this.showPasswordMsg) {
                this.confirmPasswordNotMatch = false;
                this.showPasswordMsg = false;
                this.passwordLengthInvalid = false;
                this.passwordMsg = '';
                this.passwordStrength = '';
                this.passwordMsgColor = 'red';
            }

            const passwordInput = document.getElementById("new-password");
            if (passwordInput.value.length < 6) {
                this.passwordLengthInvalid = true;
                this.showPasswordMsg = true;
                this.passwordMsg = 'create_password_with_at_least_6_characters';
                return false;
            }
            else {
                return true;
            }
        },
        backToSettings: function() {
            this.changingPasswordLoading = false;
            this.changingPasswordFailed = false;
            this.changingPasswordSuccesseded = false;
            this.changingPasswordErrMsg = '';
            this.passwordMsg = '';
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            this.showPasswordMsg = false;
            this.confirmPasswordNotMatch = false;
            this.passwordStrength = '';
            this.passwordLengthInvalid = false;
            this.$router.push('/settings');
        },
        // goBack: function() {
        //     history.back();
        // },
        changePasswordHandle: async function (e) {
            e.preventDefault();

            this.changingPasswordFailed = false;
            this.changingPasswordSuccesseded = false;
            this.changingPasswordErrMsg = '';
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            this.showPasswordMsg = false;
            this.confirmPasswordNotMatch = false;
            this.passwordStrength = '';
            this.passwordLengthInvalid = false;
            this.changingPasswordLoading = true;

            const checkPasswordStrengthResponse = this.checkPasswordLength();

            if (!checkPasswordStrengthResponse) {
                this.changingPasswordLoading = false;
            }
            else {
                const currentPassword = document.getElementById("current-password").value;
                const newPassword = document.getElementById("new-password").value;
                const confirmPassword = document.getElementById("confirm-password").value;

                // console.log(currentPassword, newPassword);

                if (newPassword !== confirmPassword) {
                    this.changingPasswordLoading = false;
                    this.confirmPasswordNotMatch = true;
                }
                else if (currentPassword === newPassword) {
                    this.changingPasswordLoading = false;
                    this.showPasswordMsg = true;
                    this.passwordMsgColor = 'red';
                    this.passwordLengthInvalid = true;
                    this.passwordMsg = "current_password_new_password_same";

                }
                else {
                    const data = {
                        currentPassword,
                        newPassword,
                        token: this.$store.user.token,
                        email: this.$store.user.email,
                    }

                    try {
                        const changePasswordResponse = await fetch('api/user/changePassword', {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json; charset=UTF-8',
                            },
                            body: JSON.stringify(data),
                        });

                        // console.log(changePasswordResponse);

                        const changePasswordResponseJson = await changePasswordResponse.json();

                        if (!changePasswordResponseJson.status) {
                            if (changePasswordResponseJson.invalidToken) {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            else {
                                this.$store.errorPopupTitle = 'unexpected_error';
                                this.$store.errorPopupMsg = 'something_went_wrong_try_again'
                                this.$store.showErrorPopup = true;
                            }
                        }
                        else {
                            this.changingPasswordSuccesseded = true;
                        }
                        this.changingPasswordLoading = false;
                        this.changingPasswordErrMsg = changePasswordResponseJson.message;
                    }
                    catch (err) {
                        console.log("Error in Change Password");
                        console.log(err);
                        this.changingPasswordLoading = false;
                        // this.changingPasswordFailed = true;
                        // this.changingPasswordErrMsg = 'something_went_wrong_try_again';
                        this.$store.errorPopupTitle = 'unexpected_error';
                        this.$store.errorPopupMsg = 'something_went_wrong_try_again'
                        this.$store.showErrorPopup = true;
                    }
                }
            }
        },
    },
    async created() {
        if (!this.$store.user.zohoId) {
            try {
                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    const { email, token } = localStorageUser;
                    const userAuth = await this.$store.authUser(email, token);
                    if (!userAuth.status) {
                        if (userAuth.confirmWarning) {
                            this.$store.unconfirmedAccount = true;
                            this.$store.showFooterBackBtn = true;
                            this.$store.user.email = email;
                            this.$router.push('/confirm');
                        }
                        else if (userAuth.error) {
                            this.$store.showMainErrorPage = true;
                        }
                        else {
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'logout';
                            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                            this.$store.mustLogOut = true;
                        }
                    }
                    else {
                        this.successLoadingPage = true;
                        this.loadingPage = false;
                    }
                }
            }
            catch(err) {
                console.log(err);
                this.failedLoadingPage = true;
                this.loadingPage = false;
                this.$store.errorPopupTitle = 'unexpected_error';
                this.$store.errorPopupMsg = 'something_went_wrong_try_again'
                this.$store.showErrorPopup = true;
                // this.failedLoadingPage = true;
                // this.loadingPage = false;
                // this.$store.showMainErrorPage = true;
            }
        }
        else {
            this.successLoadingPage = true;
            this.loadingPage = false;
        }
    }
}
</script>

<style>
.change-password-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.change-password-component-container .component-wrapper {
    /* height: calc(100vh + 65px); */
    /* height: 100vh; */
    /* min-height: 600px; */
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.change-password-component-container .change-password-page-container {
    flex: 1;
    width: 100%;
    /* min-height: 500px; */
    /* height: calc(100% - 65px); */
    padding-bottom: 25px;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    overflow: auto;
    /* border: 1px solid; */
}

.change-password-component-container .spinner-container {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.change-password-component-container .loading-spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.change-password-component-container .change-password-page-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* overflow: auto; */
}

.change-password-component-container .change-password-form-container {
    width: 88%;
    max-width: 500px;
    height: 100%;
}

.change-password-component-container .form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    /* border: 1px solid red; */
}

.change-password-component-container .change-password-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}

.change-password-component-container .info-text-container {
    width: 100%;
    max-width: 250px;
    padding: calc(11%) 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.change-password-component-container .info-text-container .info-text {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.change-password-component-container .info-text-container .info-text:nth-last-of-type(2) {
    padding-bottom: 5px;
}

.change-password-component-container .info-text-container .user-email {
    /* padding: 15px 0 10px 0; */
    /* text-align: center; */
    width: 100%;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 19px;
    word-wrap: break-word;
    text-align: center;
    /* border: 1px solid red; */
}

.change-password-component-container .input-container {
    width: 100%;
    height: 70px;
    /* border: 1px solid red; */
}

.change-password-component-container .input-container:nth-of-type(4) {
    height: 55px;
}

.change-password-component-container .form-input {
    width: 100%;
    padding: 8px 6px 6px 8px;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    border: 1px solid #92d400;
    border-radius: 10px;
    color: #000000;
    display: inline-block;
    /* margin-bottom: 15px; */
}

.change-password-component-container .form-input:focus {
    outline: 1px solid #92d400;
}

.change-password-component-container input::placeholder,
.change-password-component-container textarea::placeholder {
    color: #a0a1a3;
}

.change-password-component-container .password-section-container {
    position: relative;
    /* border: 1px solid red; */
}

.change-password-component-container .show-hide-password-container {
    position: absolute;
    right: 10px;
    top: 15%;
    bottom: 15%;
    width: 25px;
    display: flex;
    cursor: pointer;
    /* border: 1px solid; */
}

[dir="rtl"] .change-password-component-container .show-hide-password-container {
  right: auto;
  left: 10px;
}

.change-password-component-container .show-hide-password-container img {
    width: 100%;
}

.change-password-component-container .error-msg-password-not-match-container,
.change-password-component-container .password-length-strength-msg-container,
.change-password-component-container .change-password-info-msg-container {
    padding: 2px 8px;
}

.change-password-component-container .error-msg-password-not-match-container p,
.change-password-component-container .password-length-strength-msg-container p,
.change-password-component-container .change-password-info-msg-container p {
    font-size: 12px;
    font-family: 'Open Sans Std', sans-serif;
}

.change-password-component-container .error-password-not-match,
.change-password-component-container .error-password-length {
    border: 1px solid #cb061d;
}

.change-password-component-container .error-password-not-match:focus,
.change-password-component-container .error-password-length:focus {
    outline: 1px solid #cb061d;
}

.change-password-component-container .weak {
    border: 1px solid #cb061d;
    /* color: #cb061d; */
}

.change-password-component-container .weak:focus {
    outline: 1px solid #cb061d;
}

.change-password-component-container .medium:focus {
    outline: 1px solid #009df4;
}

.change-password-component-container .strong:focus {
    outline: 1px solid #92d400;
}

.change-password-component-container .medium {
    border: 1px solid #009df4;
}

.change-password-component-container .strong {
    border: 1px solid #92d400;
}

.change-password-component-container .change-password-btn-container {
    width: 100%;
    height: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.change-password-component-container .change-password-btn-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.change-password-component-container .change-password-btn {
    background: #92d400;
    color: #ffffff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 29px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    padding: 6px 50px;
    /* padding: 3px 0 6px; */
    /* border: 1px solid red; */
}

[dir="rtl"] .change-password-component-container .change-password-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 4px 50px;
}

.change-password-component-container .loading-spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.change-password-component-container .change-password-info-msg-container {
    text-align: center;
}

.change-password-component-container .can-not-reset-password-text-container {
    /* flex: 0.13; */
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 10px 0;
    /* border: 1px solid red; */
}

.change-password-component-container .can-not-reset-password-text-container p {
    color: #616365;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: center;
}

.change-password-component-container .back-to-settings-page-container p {
    color: #616365;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    text-align: center;
}

.change-password-component-container .back-to-settings-page-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.change-password-component-container .back-to-settings-page-btn-container p {
    color: #009df4;
    cursor: pointer;
}

.change-password-component-container .password-change-success-container {
    width: 88%;
    max-width: 500px;
    height: 100%;
}

.change-password-component-container .password-change-success-content-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.change-password-component-container .password-change-success-content-container .info-text-container {
    max-width: 350px;
    padding: calc(15%) 0 0;
}

.change-password-component-container .back-to-settings-btn-container {
    flex: 1.5;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
    padding: calc(10%) 0 0;
}

.change-password-component-container .back-to-settings-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

[dir="rtl"] .change-password-component-container .back-to-settings-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 0 50px 4px;
}

.change-password-component-container .fialed-loading-page-container {
    flex: 1;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.change-password-component-container .fialed-loading-page-container .info-text-container {
    width: 100%;
    max-width: 475px;
    padding: 5% 0 25px;
}

.change-password-component-container .fialed-loading-page-container .info-text-container .info-text {
    font-size: 29px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 32px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.change-password-component-container .reload-btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.change-password-component-container .reload-btn {
    /* width: 50%; */
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

[dir="rtl"] .change-password-component-container .reload-btn {
    font-size: min(26px, calc(14px + 2vw));
    padding: 4px 50px;
}

@media (max-width: 425px) {
    .change-password-component-container .form-input {
        font-size: calc(10px + 0.8vw);
    }

    .change-password-component-container .error-msg-password-not-match-container p,
    .change-password-component-container .password-length-strength-msg-container p,
    .change-password-component-container .error-reset-password-info-msg-container p {
        font-size: calc(6px + 1.5vw);
    }

    .change-password-component-container .password-change-success-content-container .info-text-container p {
        font-size: calc(20px + 2vw);
    }

    .change-password-component-container .fialed-loading-page-container .info-text-container .info-text {
        font-size: 26px;
    }

    .change-password-component-container .reload-btn {
        font-size: 24px;
    }
}

@media (max-width: 375px) {
    .change-password-component-container .info-text-container .info-text {
        font-size: 26px;
    }

    .change-password-component-container .can-not-reset-password-text-container p {
        font-size: calc(10px + 1.5vw);
    }

    .change-password-component-container .password-change-success-content-container .info-text-container p {
        font-size: calc(18px + 2vw);
    }

    .change-password-component-container .back-to-settings-btn {
        font-size: 24px;
    }
}

@media (max-width: 320px) {
    .change-password-component-container .info-text-container .info-text {
        font-size: 24px;
    }

    .change-password-component-container .form-input {
        font-size: calc(7px + 1.5vw);
    }

    .change-password-component-container .error-msg-password-not-match-container p,
    .change-password-component-container .password-length-strength-msg-container p,
    .change-password-component-container .error-reset-password-info-msg-container p {
        font-size: calc(6px + 1.2vw);
    }

    .change-password-component-container .change-password-btn {
        font-size: 20px;
    }

    .change-password-component-container .can-not-reset-password-text-container p {
        font-size: calc(8px + 1.5vw);
    }

    .change-password-component-container .password-change-success-content-container .info-text-container p {
        font-size: calc(16px + 2vw);
    }

    .change-password-component-container .back-to-settings-btn {
        font-size: 20px;
    }
}

</style>